import Swal from "sweetalert2";
import CustomUploadAdapterPlugin from '@/CustomUploadAdapter.js';

// import badWordsArray from "./badword.json";
// import { useStore } from "vuex";

// const badWords = new Set(badWordsArray.map((word) => word.toLowerCase()));

// export const filterBadWords = (textRef) => {
//   const words = textRef.value.split(" ");
//   const filteredWords = words.map((word) => {
//     if (badWords.has(word.toLowerCase())) {
//       return "*".repeat(word.length);
//     }
//     return word;
//   });

//   return (textRef.value = filteredWords.join(" "));
// };

export const filterBadWords = (textRef) => {
  // Retrieve the bad words from the store
  // Key to store and retrieve the bad words from local storage\
  if (!textRef.value) {
    textRef.value = "";
    return textRef.value;
  }
  let badWords;
  const localStorageKey = "badWords";

  // Try to get bad words from local storage
  const storedBadWords = localStorage.getItem(localStorageKey);

  // If found, parse and commit to the store
  badWords = new Set(JSON.parse(storedBadWords));
  const words = textRef.value.split(/\b/);
  const filteredWords = words.map((word) => {
    if (badWords.has(word.toLowerCase().replace(/\W/g, ""))) {
      if (word.length > 2) {
        const firstChar = word[0];
        const lastChar = word[word.length - 1];
        return `${firstChar}${"-".repeat(word.length - 2)}${lastChar}`;
      } else {
        return "-".repeat(word.length);
      }
    }
    return word;
  });

  return (textRef.value = filteredWords.join(""));
};

// Asynchronous function to filter text

export const filterBadWordsWithoutValue = (textRef) => {
  // Retrieve the bad words from the store
  // Key to store and retrieve the bad words from local storage\
  if (!textRef) {
    textRef = "";
    return textRef;
  }
  let badWords;
  const localStorageKey = "badWords";

  // Try to get bad words from local storage
  const storedBadWords = localStorage.getItem(localStorageKey);
  // If found, parse and commit to the store
  badWords = new Set(JSON.parse(storedBadWords));
  const words = textRef.split(/\b/);
  const filteredWords = words.map((word) => {
    if (badWords.has(word.toLowerCase().replace(/\W/g, ""))) {
      if (word.length > 2) {
        const firstChar = word[0];
        const lastChar = word[word.length - 1];
        return `${firstChar}${"-".repeat(word.length - 2)}${lastChar}`;
      } else {
        return "-".repeat(word.length);
      }
    }
    return word;
  });

  return (textRef = filteredWords.join(""));
};

export const changesSaved = (
  notificationMessage = "Changes Successfully Saved!",
  changeWidth = 300,
  timer = 2000
) => {
  Swal.fire({
    toast: true,
    background: "#E6F5E9",
    html: `<div class="flex items-center flex-col justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50"><path fill="#4B908C" d="M25 42c-9.4 0-17-7.6-17-17S15.6 8 25 8s17 7.6 17 17s-7.6 17-17 17zm0-32c-8.3 0-15 6.7-15 15s6.7 15 15 15s15-6.7 15-15s-6.7-15-15-15z"/><path fill="#4B908C" d="m23 32.4l-8.7-8.7l1.4-1.4l7.3 7.3l11.3-11.3l1.4 1.4z"/></svg><div style="color:#4B908C; font-family: Inter, sans-serif; font-weight:normal; overflow: hidden; text-overflow: ellipsis;" class="text-sm pb-2">${notificationMessage}</div></div>`,
    // html: `<i class="fas fa-check fa-lg" style="color:#4B908C"></i> `,
    position: "top-end",
    showConfirmButton: false,
    timer: timer,
    width: changeWidth,
    padding: 10,
  });
};

export const somethingWentWrong = (
  notificationMessage = "Sorry Something Went wrong",
  changeWidth = 330,
  timer = 2000
) => {
  Swal.fire({
    toast: true,
    background: "#fe5151",
    html: ` <div class="flex items-center flex-col justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M11.001 10h2v5h-2zM11 16h2v2h-2z"/><path fill="#fff" d="M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19L12 5.137L19.344 19H4.661z"/></svg><div style="color:#fff; font-family: Inter, sans-serif; font-weight:normal;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" class="text-sm pb-2">${notificationMessage}</div></div>`,
    position: "top-end",
    showConfirmButton: false,
    timer: timer,
    padding: 10,
    width: changeWidth,
  });
};

// convert UtC 2023-09-04T10:00:35.000000Z to DAte 09/23/2022
// export function convertDateFormat(dateString) {
//   if (!dateString) {
//     return "";
//   }
//   // Create a new date object from the input string
//   const date = new Date(dateString);

//   // Extract the day, month, and year from the date object
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // Note: Months are 0-based
//   const year = date.getFullYear();

//   // Return the desired format
//   return `${month}/${day}/${year}`;
// }


export function convertDateFormat(dateString) {
  if (!dateString) {
     return "";
   }
 
   // Ensure the date string is in ISO 8601 format
   const isoDateString = new Date(dateString).toISOString().split('T')[0];
 
   // Create a new date object from the ISO date string
   const dates = new Date(isoDateString);
 
   // Extract the day, month, and year from the date object
   const day = String(dates.getDate()).padStart(2, "0");
   const month = String(dates.getMonth() + 1).padStart(2, "0"); // Note: Months are 0-based
   const year = dates.getFullYear();
 
   // Return the desired format
   return `${month}/${day}/${year}`;
 }
export function convertDateFormatWith2DigitsYear(dateString) {
  if (!dateString) {
    return "";
  }

  // Create a new date object from the input string
  const date = new Date(dateString);

  // Extract the day, month, and year from the date object
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Note: Months are 0-based
  const year = String(date.getFullYear()).slice(-2); // Get the last two digits of the year

  // Return the desired format
  return `${month}/${day}/${year}`;
}

// convert teh Date Tue Oct 10 2023 00:00:00 GMT+0500 (Pakistan Standard to 2023-01-01
export const formatDateToDashDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // pad with 0 if month is a single digit
  const day = date.getDate().toString().padStart(2, "0"); // pad with 0 if day is a single digit

  return `${year}-${month}-${day}`;
};

// convert teh Date Tue Oct 10 2023 00:00:00 GMT+0500 (Pakistan Standard to 2023-01-01
export const convertDashDateToDateObjectFormat = (date) => {
  return new Date(date);
};
// convert UtC 2023-09-04T10:00:35.000000Z to DAte 23/09/2022
export function convertDateFormatToDMY(dateString) {
  // Create a new date object from the input string
  const date = new Date(dateString);

  // Extract the day, month, and year from the date object
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Note: Months are 0-based
  const year = date.getFullYear();

  // Return the desired format
  return `${day}/${month}/${year}`;
}

export const filterTextFromBadWords = (textRef) => {
  const words = textRef.value.split(" ");
  const filteredWords = words.map((word) => {
    if (badWordsSet.has(word.toLowerCase())) {
      return "+".repeat(word.length);
    }
    return word;
  });

  textRef.value = filteredWords.join(" ");
};

// fromat 2004-12-07 06:34:58 to this 04 Sep 2023, 9:14AM
export const formatDateTime = (dateTime) => {
  // Extract the date and time parts from the input string
  const [datePart, timePart] = dateTime.split(" ");
  const [year, month, day] = datePart.split("-");
  const [hour, minute, second] = timePart.split(":");

  // Prepare an array of month names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Convert month index to month name
  const monthName = months[parseInt(month, 10) - 1];

  // Convert to 12-hour time format and set the AM/PM part
  let ampm = "AM";
  let formattedHour = parseInt(hour, 10);

  if (formattedHour > 12) {
    formattedHour -= 12;
    ampm = "PM";
  } else if (formattedHour === 12) {
    ampm = "PM";
  } else if (formattedHour === 0) {
    formattedHour = 12;
  }

  // Combine all the components to form the final formatted date-time
  const formattedDateTime = `${day} ${monthName} ${year}, ${formattedHour}:${minute}${ampm}`;

  return formattedDateTime;
};
// convert UtC 2023-09-04T10:00:35.000000Z to DAteTime  04 Sep 2023, 9:14AM
export const formatUTCToDateTime = (dateString) => {
  // Parse the date string into a Date object
  const date = new Date(dateString);

  // Create an array for month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract day, month, and year
  const day = date.getUTCDate();
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  // Extract time
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert 24-hour time format to 12-hour format
  const hours12 = hours % 12 || 12;

  // Add leading zeros to minutes less than 10
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;

  // Construct the final string
  return `${day} ${month} ${year}, ${hours12}:${minutesStr}${ampm}`;
};
export const toolbarConfig = {
  toolbar: {
    removeItems: ["uploadImage", "mediaEmbed"], // Remove specific items from toolbar
  },
};
export const toolbarConfigPost = {
  toolbar: {
    removeItems: ["mediaEmbed", "strikethrough"], // Remove specific items from toolbar
  },

  fontFamily: {
    options: [
      'default',
      'Arial, Helvetica, sans-serif',
      'Courier New, Courier, monospace',
      'Georgia, serif',
      'Lucida Sans Unicode, Lucida Grande, sans-serif',
      'Tahoma, Geneva, sans-serif',
      'Times New Roman, Times, serif',
      'Trebuchet MS, Helvetica, sans-serif',
      'Verdana, Geneva, sans-serif',
      'Comic Sans MS, cursive, sans-serif',
      'Nunito, sans-serif', 
      // Add more font families here
    ],
    supportAllValues: true
  },
  fontSize: {
    options: [
      '8px', '10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px'
    ],
    supportAllValues: true
  },
  extraPlugins: [CustomUploadAdapterPlugin] 
};
export const startOptionToArray = (option) => {
  let newOption = [];
  // Iterate through each key-value pair in the original option
  for (const [key, value] of Object.entries(option)) {
    // If the key starts with "color", add it to the newOption
    if (key.startsWith("color")) {
      newOption.push(value);
    }
  }
  return newOption;
};

export const timeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const years = Math.floor(weeks / 52);

  if (years > 0) return `${years}y`;
  if (weeks > 0) return `${weeks}w`;
  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;
  return "just now";
};

function hexToRgb(hex) {
  // console.log(hex, "hexToRgb");
  // Ensure the hex code is in the 6-digit format
  if (hex.charAt(0) === "#") {
    hex = hex.substr(1);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return [r, g, b];
}

function rgbToHex(r, g, b) {
  return (
    "#" +
    ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()
  );
}

function lighten(hex, percent) {
  const [r, g, b] = hexToRgb(hex);
  const amount = (percent / 100) * 255;

  return rgbToHex(
    Math.min(255, r + amount),
    Math.min(255, g + amount),
    Math.min(255, b + amount)
  );
}

function darken(hex, percent) {
  const [r, g, b] = hexToRgb(hex);
  const amount = (percent / 100) * 255;

  return rgbToHex(
    Math.max(0, r - amount),
    Math.max(0, g - amount),
    Math.max(0, b - amount)
  );
}

export { lighten, darken, hexToRgb };
